export const TIX_SESSION_COOKIE = 'session'
export const TIX_SESSION_EXPIRES_COOKIE = 'session_expires'
export const VALIDATION_COOKIE_NAME = 'mnedf'
export const AUTH_COOKIE_NAME = 'eiryw'
export const MOBILE_APP_COOKIE = 'K4t7B3sP'
export const MOBILE_APP_COOKIE_VALUE = 'M9p6W2zQ'
export const PREVIEW_SITE_COOKIE = 'previewSite'
export const GUEST_CART_IDS_KEY = 'guest-cart-id'

export const SESSION_EXPIRED = 'session_expired'
export const LOGIN_FAILED = 'login_failed'
export const MODAL_COOKIE_ERRORS = [SESSION_EXPIRED, LOGIN_FAILED]

export const ERROR_MODAL_COOKIE = 'mw_error_modal'
export const ERROR_NOTIFICATIONS_COOKIE = 'mw_error_notification'
export const DISMISSED_PORTAL_MODAL_COOKIE = 'dismissedPortalModal'
export const DISMISSED_PORTAL_MODAL_COOKIE_VALUE = 'true'

// suppress auth header for gift recipient user creation and getting booked order
// this prevents errors for logged-in users
export const REPRESS_AUTH_HEADER = 'x-repress-auth'
